import { OrganizationVideo } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import React from 'react';
import { NewModal } from '../NewModal';
import { OrganizationVideoForm } from './OrganizationVideoForm';

type ModalProps = {
  handleModalClose: () => void;
  organizationVideo?: OrganizationVideo;
  prefillData?: Omit<OrganizationVideo, 'organizationVideoId'>;
};

export const ModalOrganizationVideoForm = ({
  handleModalClose,
  organizationVideo,
  prefillData,
}: ModalProps) => {
  const isEdit = !!organizationVideo && !!prefillData;
  const isPrefill = !organizationVideo && !!prefillData;

  const headerText = isEdit
    ? organizationVideo.title
    : isPrefill
      ? 'Duplicate Organization Video'
      : 'Add Organization Video';

  return (
    <NewModal
      closeModal={handleModalClose}
      headerText={headerText}
      style={{
        content: { maxWidth: '900px', minWidth: '900px', maxHeight: '90vh' },
      }}
      hideCloseButtonInHeader
      closeModalOnBackdropOrEscPress={false}
    >
      <OrganizationVideoForm
        organizationVideo={organizationVideo}
        prefillData={prefillData}
        onSuccess={handleModalClose}
      />
    </NewModal>
  );
};
